import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

import { BreadcrumbsComponent } from './breadcrumbs.component';
import { BreadcrumbsService } from './breadcrumbs.typings';
import { RoutingBreadcrumbsService } from './routing-breadcrumbs.service';

export const imports: NgModule['imports'] = [FlexLayoutModule, MatIconModule];

@NgModule({
  declarations: [BreadcrumbsComponent],
  imports: [...imports, CommonModule, RouterModule],
  exports: [BreadcrumbsComponent, MatIconModule],
  providers: [{ provide: BreadcrumbsService, useClass: RoutingBreadcrumbsService }],
})
export class BreadcrumbsModule {}
